import Head from 'next/head';
import React from 'react';
import { ArticlesList } from '../components';
import { withLayout } from '../Layout/Layout';

function TopLists() {
  return (
    <>
      <Head>
        <link rel="canonical" href={`${process.env.apiUrl}/guides`} />
        <meta
          name="description"
          content={
            'Access a wealth of travel guides and resources on First-Class.com. Get expert advice, travel tips, and recommendations for your next journey'
          }
        />
        <title>Guides: Comprehensive Travel Guides and Tips</title>
      </Head>
      <ArticlesList type="Guides" heading="Guides" />
    </>
  );
}

export default withLayout(TopLists, true);
